import { useNotificationToast } from '@/lib/hooks/useNotificationToast';
import { useEffect } from 'react';
import store from '../redux/configureStore';
import { addBookmark } from '../redux/features/bookmark/addBookmark';

const enum BookmarkStates {
  SAVED = 'saved',
  APPLIED = 'applied',
  IN_PROGRESS = 'in_progress',
  SUCCESSFUL = 'successful',
  UNSUCCESSFUL = 'unsuccessful',
  PREREGISTERED = 'pre-registered'
}

export const useBookmarkHandle = async (isSignedIn: boolean, bookmarks: any) => {
  const { showNotificationToast } = useNotificationToast();

  useEffect(() => {
    if (!isSignedIn || bookmarks.status !== 'loaded') {
      return;
    }
    (async () => {
      const params = new URLSearchParams(location.search);
      const bookmarkItemId = params.get('bookmarkItemId') ?? '';
      let bookmarkState = params.get('bmstate') ?? '';
      // Default to saved, a regular bookmark
      bookmarkState = Object.values(BookmarkStates).includes(bookmarkState) ? bookmarkState : BookmarkStates.SAVED;
      if (bookmarkItemId) {
        store
          .dispatch(addBookmark({ entityUuid: bookmarkItemId, state: { label: bookmarkState } }))
          .then((response: any) => {
            if (response && response.success !== false) {
              showNotificationToast({
                type: 'success',
                message: 'Saved! You can now find me in your dashboard.',
                config: {
                  autoClose: 3000
                }
              });
            } else {
              showNotificationToast({
                type: 'error',
                message: 'Sorry, something went wrong.'
              });
            }
          });
        // we only want to run once so update after done
        history.replaceState(
          {},
          document.title,
          `${document.location.pathname}${document.location.search.replace('bookmarkItemId=' + bookmarkItemId, '')}`
        );
      }
      return;
    })();
  }, [isSignedIn, bookmarks.status]);
};
